"use strict";

var React = require('react');
var PropTypes = React.PropTypes;

function ModalClose(props) {
  return React.createElement("span", { className: "cf-modal__close", onClick: props.onClick });
}

ModalClose.propTypes = {
  onClick: PropTypes.func.isRequired
};

module.exports = ModalClose;